exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vc-checkerboard{position:absolute;top:0;right:0;bottom:0;left:0;background-size:contain}", ""]);

// exports
